module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showUpBox(null)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加租赁商品\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.listData.length > 10
    }
  }, _vm._l((_vm.listData), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "img_box"
    }, [_c('img', {
      staticStyle: {
        "width": "50px",
        "height": "50px",
        "margin": "20px 0"
      },
      attrs: {
        "src": item.image + '?x-oss-process=image/resize,l_300',
        "alt": ""
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.productTypeName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.queue)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.totalCount)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [(item.id) ? _c('span', {
      style: (item.showPcEnabled ? 'color:green' : 'color:red')
    }, [_vm._v(_vm._s(item.showPcEnabled ? "是" : "否"))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [(item.id) ? _c('span', {
      style: (item.buyEnabled ? 'color:green' : 'color:red')
    }, [_vm._v(_vm._s(item.buyEnabled ?
      "是" : "否"))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "right",
        "padding-right": "5%"
      }
    }, [(item.id) ? _c('span', {
      staticStyle: {
        "margin": "0 2%",
        "cursor": "pointer"
      },
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.showUpBox(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]) : _vm._e(), _vm._v(" "), (item.id) ? _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '添加/编辑租赁商品',
      "visible": _vm.addAddrBtn,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addAddrBtn = $event
      }
    }
  }, [_c('div', {
    staticClass: "msgWrap"
  }, [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品分类")]), _vm._v(" "), _c('el-select', {
    staticClass: "itemSelect",
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "placeholder": "请选择分类"
    },
    model: {
      value: (_vm.form.productTypeId),
      callback: function($$v) {
        _vm.$set(_vm.form, "productTypeId", $$v)
      },
      expression: "form.productTypeId"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "msgWrap"
  }, [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("排序值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.queue),
      expression: "form.queue"
    }],
    staticClass: "itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.form.queue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "queue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("总库存数量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.totalCount),
      expression: "form.totalCount"
    }],
    staticClass: "itemInput",
    attrs: {
      "type": "number",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.form.totalCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "totalCount", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "msgWrap"
  }, [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("展示到PC")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.form.showPcEnabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "showPcEnabled", $$v)
      },
      expression: "form.showPcEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.form.showPcEnabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "showPcEnabled", $$v)
      },
      expression: "form.showPcEnabled"
    }
  }, [_vm._v("否")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("是否能购买")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.form.buyEnabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "buyEnabled", $$v)
      },
      expression: "form.buyEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.form.buyEnabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "buyEnabled", $$v)
      },
      expression: "form.buyEnabled"
    }
  }, [_vm._v("否")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "msgWrap"
  }, [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "msgItem",
    staticStyle: {
      "justify-content": "normal",
      "margin-bottom": "0px"
    }
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品押金")]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.modifyExtra('add')
      }
    }
  }, [_vm._v("添加数据")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "msgItem",
    staticStyle: {
      "justify-content": "normal",
      "margin-bottom": "0px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont-list"
  }, [(_vm.showRule) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form.extras,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "120",
      "label": "押金金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (scope.row.amount),
            callback: function($$v) {
              _vm.$set(scope.row, "amount", $$v)
            },
            expression: "scope.row.amount"
          }
        })]
      }
    }], null, false, 3878719626)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "计费方式",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": function (e) { return _vm.changeItemRule(e, scope.row); }
          },
          model: {
            value: (scope.row.ruleId),
            callback: function($$v) {
              _vm.$set(scope.row, "ruleId", $$v)
            },
            expression: "scope.row.ruleId"
          }
        }, _vm._l((_vm.ruleList), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1)]
      }
    }], null, false, 1925993299)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "适用区域（仅针对PC客户端）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "width": "100%"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "multiple": "",
            "placeholder": "不选择区域，则默认为全场..."
          },
          model: {
            value: (scope.row.options),
            callback: function($$v) {
              _vm.$set(scope.row, "options", $$v)
            },
            expression: "scope.row.options"
          }
        }, _vm._l((_vm.regionData), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1)], 1)]
      }
    }], null, false, 510709140)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "PC默认规则",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          model: {
            value: (scope.row.defaultPcRule),
            callback: function($$v) {
              _vm.$set(scope.row, "defaultPcRule", $$v)
            },
            expression: "scope.row.defaultPcRule"
          }
        })]
      }
    }], null, false, 3155441348)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.modifyExtra('del', scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 947840140)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "msgWrap"
  }, [_c('div', {
    staticClass: "msgBox img_box clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品图片")]), _vm._v(" "), _c('div', {
    staticClass: "left img",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "img_item left"
  }, [(_vm.form.image) ? _c('img', {
    ref: "goodsImg",
    attrs: {
      "src": _vm.form.image + '?x-oss-process=image/resize,l_300',
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.image) ? _c('span', {
    staticClass: "del-img",
    on: {
      "click": _vm.delImg
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "img_up_btn left"
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai"
  }), _vm._v(" "), _c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": _vm.coverImg
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mobileImgFile",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.coverImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "uploadImgTip"
  }, [_vm._v("\n              支持JPG、JPEG、PNG格式，单张大小不超过5M，建议尺寸 600*600 px\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox img_box clearfix"
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addAddrBtn = false
      }
    }
  }, [_vm._v("\n        取消\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addFn
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                商品图片\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                商品名称\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                分类名称\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                排序值\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                总库存数\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                展示至PC\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                允许购买\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "right",
      "padding-right": "5%"
    }
  }, [_vm._v("\n                操作\n              ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0b7a5630","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/rent/goods/index.vue
// module id = 917
// module chunks = 1